import { render } from "./p-slider.vue?vue&type=template&id=a417f822&scoped=true"
import script from "./p-slider.vue?vue&type=script&lang=js"
export * from "./p-slider.vue?vue&type=script&lang=js"

import "./p-slider.vue?vue&type=style&index=0&id=a417f822&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a417f822"]])

export default __exports__